

export default function Footer() {
    return(
        <footer>
            <p>WebFix-Studio. All Rights Reserved &#64; 2023</p>
            <p>Designed by <a href="https://www.linkedin.com/in/luis-villarreal7/" target="_blank" rel="noreferrer" className="link">Luis Villarreal</a></p>
        </footer>
    )
}